import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { useVendorsApiClient } from 'vendors/api/useVendorsApiClient'

export const useHistoryTimelineQuery = (vendorId: string): UseQueryResult<VendorHistoryTimeline[]> => {
  const { getHistoryTimelineByVendorId } = useVendorsApiClient()

  return useQuery<VendorHistoryTimeline[]>({
    queryKey: ['history-timeline', vendorId],
    queryFn: () => getHistoryTimelineByVendorId(vendorId),
    enabled: vendorId !== '',
    refetchOnWindowFocus: false
  })
}
